<template>
  <div v-if="dataWasDownloadedSuccessfully">
    <div v-for="(job, idx) in jobs" :key="idx" class="collapsable-box mt-2">
      <input type="checkbox" :id="'jobs_all'+idx">
      <label class="btn btn-max" :for="'jobs_all'+idx">
        <i class="icon-"></i>
        <span>
          {{job.fields.title}} - {{job.fields.city}}
        </span>
      </label>

      <div v-if="jobs" class="collapsable-content">
        <div class="font-xs">
          <div class="px-3 py-4">
            <h4>
              {{job.fields.title}}
            </h4>
            <!-- description as markdown -->
            <div v-html="$sanitize($markdown.makeHtml(job.fields.description))"></div>
          </div>
          <div class="colophon bg-brwn-lght p-4">
            <div class="d-flex flex-align-center flex-space-between flex-column flex-md-row">
              <div>
                <!-- keep hardcoded -->
                <h4 class="mb-2">Interessiert?</h4>
                <p>Dann bewerben Sie sich jetzt hier via E-mail.</p>
              </div>
              <div>
                <!-- adjust only subject line with: {{job.fields.title}} -->
                <a class="btn btn-primary" :href="formatString(job.fields.title, mailto)">
                  Bewerben
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getContent } from '@/javascripts/contentful';

  export default {
    name: 'jobOffersApp',
    props: ['entryId'],
    data() {
      return {
        dataWasDownloadedSuccessfully: false,
        jobs: null,
        mailto: '',
        formatString: (title, email) => {
          let string = `mailto:${email}?subject=`
          string += title;
          string += '&body=Bitte%20erg%C3%A4nzen%20Sie%20f%C3%';
          string += 'BCr%20Ihre%20Bewerbung%20die%20folgenden%20Punkte.';
          string += '%0D%0A';
          string += '%0D%0A Vorname%3A';
          string += '%0D%0A Nachname%3A';
          string += '%0D%0A Telefon%3A';
          string += '%0D%0A E-mail%3A';
          string += '%0D%0A Verf%C3%BCgbar%20ab%3A';
          string += '%0D%0A Gehaltsvorstellung%3A';
          string += '%0D%0A';
          string += '%0D%0A';
          string += 'Anschreiben%2C%20Lebenslauf%20und%20Zeugnisse%20bitte%20als%20PDF%20anh%C3%A4ngen!';
          return string
        }
      }
    },
    async mounted() {
      const { fields } = await getContent(this.entryId)

      if (fields) {
        this.jobs = { ...fields.jobsPostings }
        this.mailto = fields.mailto
        this.dataWasDownloadedSuccessfully = true
      }
    },
  }
</script>
